export default "__VITE_ASSET__Dk6kkqWR__"